import { itemInfo, species } from "@redchain/gen1-data";
import { isBlankSram, parseSave } from "@redchain/gen1-save";

export interface InventoryMon { name: string; species: number; level: number; location: string }
export interface Inventory { party: InventoryMon[]; pc: InventoryMon[]; items: { name: string; quantity: number; location: string }[]; money: number }
export function readInventory(sram: Uint8Array): Inventory | null {
  try {
    if (isBlankSram(sram)) return null;
    const save = parseSave(sram);
    const mons = save.mons.map(m => ({
      name: m.nicknameText || species(m.box.species)?.name || "Unknown Pokémon",
      species: m.box.species, level: m.party?.partyLevel ?? m.box.level,
      location: m.location.kind === "box" ? `Box ${m.location.box + 1}` : m.location.kind === "daycare" ? "Day Care" : "Party",
    }));
    return {
      party: mons.filter(m => m.location === "Party"), pc: mons.filter(m => m.location !== "Party"), money: save.money,
      items: [
        ...[...save.bag, ...save.pockets].map(i => ({ ...i, location: "Bag" })),
        ...save.pcItems.map(i => ({ ...i, location: "PC" })),
      ].filter(i => i.qty > 0).map(i => ({ name: itemInfo(i.id)?.name ?? `Item ${i.id}`, quantity: i.qty, location: i.location })),
    };
  } catch { return null; }
}
